/**
 * 更新用モジュール
 */
import { ThunkAction } from 'redux-thunk';

import { deleteErrorSenetence } from '../services/contractApi';
// export { DeleteResult, DeleteResult } from '../services/contractApi';

export interface DeleteState {
  deleteMessages: string[];
  statusD: number;
}

const initialState: DeleteState = {
  deleteMessages: [],
  statusD: 0,
};

const START_DELETE = 'START_DELETE';
type START_DELETE = typeof START_DELETE;

const FINISH_DELETE = 'FINISH_DELETE';
type FINISH_DELETE = typeof FINISH_DELETE;

const FAIL_DELETE = 'FAIL_DELETE';
type FAIL_DELETE = typeof FAIL_DELETE;

const CLEAR_DELETE = 'CLEAR_DELETE';
type CLEAR_DELETE = typeof CLEAR_DELETE;

interface StartDelete {
  type: START_DELETE;
  index: number;
}

interface FinishDelete {
  type: FINISH_DELETE;
  index: number;
}

interface ClearDelete {
  type: CLEAR_DELETE;
}

interface FailDelete {
  type: FAIL_DELETE;
  index: number;
  deleteMessages: string[];
  status: number;
}

export type DeleteAction = StartDelete | FinishDelete | FailDelete | ClearDelete;

type PostDelete =
  ThunkAction<void, DeleteState, undefined, DeleteAction>;

export function startDelete(index: number): StartDelete {
  return {
    index,
    type: START_DELETE,
  };
}

export function finishDelete(index: number): FinishDelete {
  return {
    index,
    type: FINISH_DELETE,
  };
}

export function clearDelete(): ClearDelete {
  return {
    type: CLEAR_DELETE,
  };
}

export function failDelete(index: number, deleteMessages: string[], status: number): FailDelete {
  return {
    index,
    deleteMessages,
    status,
    type: FAIL_DELETE,
  };
}

export function deleteContent(index: number, id: string): PostDelete {
  return (dispatch) => {
    dispatch(startDelete(index));
    return deleteErrorSenetence(id).then((res) => {
      const { status, result, messages, status_code } = res;
      if (status === 200 && result) {
        dispatch(finishDelete(index));
      } else {
        dispatch(failDelete(index, messages, status_code));
      }
    }).catch((err) => {
      dispatch(failDelete(index, [String(err)], 500));
    });
  };
}

export default function reducer(
  state: DeleteState | undefined,
  action: DeleteAction,
): DeleteState {
  if (!state) return initialState;
  switch (action.type) {
    case START_DELETE: {
      return { ...state };
    }
    case FINISH_DELETE: {
      return { ...state, deleteMessages: [] };
    }
    case CLEAR_DELETE: {
      return initialState;
    }
    case FAIL_DELETE: {
      const { deleteMessages, status } = action;
      return { ...state, deleteMessages, statusD: status };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/delete.ts